//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[[0,"BlockOffset",1,0],[0,"DeletePreviousDiagrams",1,0],[0,"InsertionPoint",1,"Point",0],[0,"NumberOfRows",1,0],[0,"ReferencePlane",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.TabNoteCfgBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TabNoteCfgBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TabNoteCfgBuilder.Refplane = Object.freeze({
    "Xy" : "Xy", "Yz" : "Yz", "Zx" : "Zx", "NegXy" : "NegXy", "NegYz" : "NegYz", "NegZx" : "NegZx"});

export default SPLM;